import { Source } from "./chat.model";
import { TwitterVideoModel } from "./twitter-video.model";

export interface LeaderBoard {
  firstName: string;
  info_amount: number;
  lastName: string;
  playerId: string;
  previousRank: number;
  rank: number;
  relative: number;
  totalPoints: number;
  interaction: LeaderboardInteraction;
  timeFrame: string;
  interactionLoading: boolean;
  open: boolean;
  country: string;
  country_flag: string;
  like: boolean;
  dislike: boolean;
}
export interface LeaderBoardObj {
  totalResults: number,
  totalPages: number,
  page: number,
  limit: number,
  lastUpdated: string,
  data: LeaderBoard[]
}

export interface LeaderboardInteraction {
  results: string;
  videos: string[];
  topic: LeaderboardTopic[];
  topics?: string[];
  recent_tourn: string[];
  tournaments: LeaderboardNews[];
  sources: Source[];
  overview: string;
  showVideoSlider: boolean;
  showAnalyzeTab: boolean;
  prompt: string;
  openTab?: boolean;
  like: boolean;
  dislike: boolean;
  twitterVideos: TwitterVideoModel[];
}

export interface LeaderboardTopic {
  name: string;
  response: string;
}

export interface LeaderboardNews {
  name: string;
  response: string;
}


export interface Schedule {
  name: string;
  date_start: string;
  date_end: string;
  tournId: string;
  leaderboard: TournamentResult;
  courseName: string;
  winnerShare: string;
  status: string;
  country: string;
  country_flag: string;
}

export interface TournamentResult {
  status: string;
  roundStatus: string;
  cutCount: number;
  cutScore: string;
  lastUpdated: string; // ISO date string
  courseName: string;
  courseId: string;
  leaderboardRows: LeaderboardRow[];
  selectedRound: number;
  maxRounds: number;
  totalHotCount: number;
  totalColdCount: number;
  totalEyesCount: number;
}


export interface TopicDetail {
  title: string;
  description: string;
}
export interface RoundDetail {
  results: string;
  sources: Source[];
  videos: string[];
  topics: string[];
  round: number;
  roundAnalysis: string;
  showVideoSlider: boolean;
  topicDetails: TopicDetail[];
  openAnalyze: boolean;
  prompt: string;
  twitterVideos: TwitterVideoModel[];
  like: boolean;
  dislike: boolean;
}
export interface LeaderboardRow {
  firstName: string;
  lastName: string;
  playerId: string;
  position: string;
  total: string; // Score to par (e.g., "-17")
  currentRoundScore: string;
  totalStrokesFromCompletedRounds: string;
  currentHole: number;
  startingHole: number;
  roundComplete: boolean;
  info_amount: number;
  relative: number;
  rounds: Round[];
  thruValue: string;
  thru: string;
  selectedRound: number;
  roundDetails: RoundDetail[];
  roundLoading: boolean;
  open: boolean;
  status: string;
  teamName: string;
  country: string;
  country_flag: string;
  hot: boolean;
  cold: boolean;
  eyes: boolean;
}

export interface Round {
  scoreToPar: string;
  roundId: number;
  strokes: number | string;
  info_amount: number;
  relative: number;
  hot: boolean;
  cold: boolean;
  eyes: boolean;
}

export interface ShareDiscover {
  tab: string,
  tournId?: string, 
  playerId: string,
  round?: string,
  content: string,
  videos: string[],
  sources: Source[],
  topics: string[],
  question: string,
  page?: number
}

export class embedClient {
  clientId = '';
  clientName = '';
  imageDirectory = '';
  url = '';
}